import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchIcon } from '@velasca/icons/search'
import { formatCountries } from '@velasca/utils/format-countries'
import { getStoreUrlByCountry } from '@velasca/utils/get-store-url-by-country'
import { $settings } from '@velasca/utils/globals'
import { handleError } from '@velasca/utils/handle-error'
import { IconButton } from '../IconButton/IconButton'
import {
  ButtonSearch,
  Columns,
  Container,
  CountryWrap,
  InputBar,
  InputContainer,
  Title,
} from './SwitchStore.styles'
import type { SwitchStoreProps } from './SwitchStore.types'

const domainsRegistry = {
  row_domain: window.row_domain,
  eu_domain: window.eu_domain,
  it_domain: window.it_domain,
  fr_domain: window.fr_domain,
  uk_domain: window.uk_domain,
  dk_domain: window.dk_domain,
  us_domain: window.us_domain,
  de_domain: window.de_domain,
  eu_isocode: window.eu_isocode,
  it_isocode: window.it_isocode,
  fr_isocode: window.fr_isocode,
  uk_isocode: window.uk_isocode,
  dk_isocode: window.dk_isocode,
  us_isocode: window.us_isocode,
  de_isocode: window.de_isocode,
}

export const SwitchStore = ({
  countryList = window.countryList,
}: SwitchStoreProps): JSX.Element => {
  const countries = formatCountries(countryList, $settings.language)

  const { t } = useTranslation('switch-country')
  const title = t('switchStoreTitle')
  const placeHolder = t('switchStoreSearchBar')
  const [searched, setSearched] = useState('')
  const filteredResult = useMemo(() => {
    return countries.filter((country) => {
      if (!country.label) {
        handleError(
          new Error(
            'ERROR: there is a Country with undefined label, please check the data.',
          ),
        )

        return false
      }

      return country.label
        .toLowerCase()
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '')
        .includes(searched.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, ''))
    })
  }, [countries, searched])

  return (
    <Container>
      <Title>{title}</Title>
      <InputContainer>
        <InputBar
          placeholder={placeHolder}
          value={searched}
          onChange={(e) => {
            setSearched(e.target.value.toLowerCase())
          }}
        />
        <ButtonSearch disabled={searched === ''}>
          <IconButton color="#fff">
            <SearchIcon />
          </IconButton>
        </ButtonSearch>
      </InputContainer>
      <Columns>
        {filteredResult.map((country) => {
          return (
            <CountryWrap key={country.label}>
              <a href={getStoreUrlByCountry(country.code, domainsRegistry)}>
                {country.label}
              </a>
            </CountryWrap>
          )
        })}
      </Columns>
    </Container>
  )
}
